import { mapState } from 'vuex';

export default {
    name: 'setpicture',
    props: {
    },

    data : function(){

        return {
            loading : false,
            files : [],
            error : null,
            selected : null
        }

    },

    created() {
        this.load()
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
    }),

    methods : {
        load : function () {
            this.loading = true

            this.core.api.user.getpictures().then((files) => {
                this.error = null
                this.files = files

            }).catch(e => {
                this.error = e
            }).finally(() => {
                this.loading = false
            })

        },

        save : function(){

            if(!this.selected) return

            this.core.api.user.setpicture(this.selected).then((files) => {
                this.$store.commit('icon', {
                    icon: 'success'
                })

                this.$emit('close')

            }).catch(e => {

                this.$store.commit('icon', {
                    icon: 'error'
                })

            })
    
            

        },
        cancel : function(){
            this.$emit('close')
        },

        select : function(file){
            this.selected = file
        }
    },
}